import type { Locale } from '@tuic/i18n';

/** XiCafe captive portal domain on the ship's local network. */
export const XI_CAFE_DOMAIN = 'https://internet.meinschiff.de';

/** XiCafe captive portal entry point. Append `?token=<JWT>` to auto-login the user. */
export const XI_CAFE_CAPTIVE_PORTAL_BASE_URL = `${XI_CAFE_DOMAIN}/tuic/guestlogin.aspx`;

/**
 * Maps the dashboard locale to the `lang` value XiCafe expects on the portal URL.
 * 1 → German, 3 → English. XiCafe persists the choice once the page has loaded.
 */
const localeToXiCafeLang = (locale: Locale): '1' | '3' =>
  locale === 'en' ? '3' : '1';

/**
 * Builds the XiCafe captive portal URL.
 *
 * - `?token=<JWT>` is omitted entirely when `token` is `null`, so the portal
 *   renders its standard login screen instead of failing on an empty token.
 * - `?lang=` reflects the dashboard locale (1 = de, 3 = en).
 * - `?embed=1` always set — signals XiCafe to render in iframe-mode chrome.
 */
export const getXiCafeCaptivePortalUrl = (
  token: string | null,
  locale: Locale,
): string => {
  const params = new URLSearchParams();
  if (token) params.set('token', token);
  params.set('lang', localeToXiCafeLang(locale));
  params.set('embed', '1');

  return `${XI_CAFE_CAPTIVE_PORTAL_BASE_URL}?${params.toString()}`;
};
